import {useMemo} from "react";
import {useAtomValue} from "jotai";
import {selectedEntityAtom} from "../store/filterSelectionStore";
import {createFeatureCollection} from "../utils/mapUtils";
import {useActiveCompanyFields} from "./activeCompanyFieldsHooks";

export const useFieldsGeojson = () => {
    const fieldsState = useActiveCompanyFields();
    const fields = useMemo(() => (fieldsState.isSuccess ? fieldsState.data.fields : []), [fieldsState]);
    const mapByFarmId = useMemo(() => (fieldsState.isSuccess ? fieldsState.data.mapByFarmId : {}), [fieldsState]);
    const mapByFieldId = useMemo(() => (fieldsState.isSuccess ? fieldsState.data.mapByFieldId : {}), [fieldsState]);
    const selectedEntity = useAtomValue(selectedEntityAtom);

    const _fields = useMemo(() => {
        if (fieldsState && selectedEntity) {
            if (selectedEntity.entityType === "company") {
                return fields;
            } else if (selectedEntity.entityType === "farm") {
                return mapByFarmId[selectedEntity.entityId];
            } else {
                const field = mapByFieldId[selectedEntity.entityId];
                if (field === undefined) {
                    return null;
                } else {
                    return field.farmId ? mapByFarmId[field.farmId] : [field];
                }
            }
        } else {
            return null;
        }
    }, [fields, fieldsState, mapByFarmId, mapByFieldId, selectedEntity]);

    return useMemo(() => {
        if (_fields) {
            return createFeatureCollection(_fields);
        } else {
            return null;
        }
    }, [_fields]);
};
